type EventFormPermissionUser = {
  can_manage_event_forms?: boolean;
};

export const hasEventFormManagementPermission = (
  user?: EventFormPermissionUser | null,
) => Boolean(user?.can_manage_event_forms);
